import { ready } from '~/core'

ready('jumpNav', '.jumpNav', (jumpNav) => {
  // deal with event handlers on case-by-case basis if given an id
  if (jumpNav.id) return

  const status = jumpNav.querySelector('.jumpNav-status')
  const links = jumpNav.querySelectorAll('.jumpNav-link')

  const toggleOpen = () => {
    jumpNav.classList.contains('is-expanded')
      ? jumpNav.classList.remove('is-expanded')
      : jumpNav.classList.add('is-expanded')
  }
  window.addEventListener('click', (e) => {
    if (e.target !== status && !e.target.closest('.jumpNav-status')) {
      jumpNav.classList.remove('is-expanded')
    }
  })
  if (status != null) {
    status.addEventListener('click', toggleOpen)
  }

  links.forEach((item) => {
    item.addEventListener('focus', (e) => {
      if (!jumpNav.classList.contains('is-expanded')) {
        jumpNav.classList.add('is-expanded')
      }
    })
    item.addEventListener('blur', (e) => {
      if (!jumpNav.contains(document.activeElement)) {
        jumpNav.classList.remove('is-expanded')
      }
    })
  })
})
